<template>
  <div class="d-flex justify-center px-3">
    <v-btn small class="mr-3 px-4 py-4" color="font" @click="social_auth_github">
      <v-icon class="fa fa-github mr-2"></v-icon>
      GitHub Sign In
    </v-btn>

    <v-btn small class="px-4 py-4" color="font" :disabled="!googleLoaded" @click="social_auth_google">
      <v-img src="/google_logo.svg" class="mr-2" style="width:20px;"></v-img>
      Google Sign In
    </v-btn>
  </div>
</template>

<script>
import constants from "@/config/constants";
import googleAuth from "@/utils/googleAuth";
import {getCookie, getFirstTouch} from "@/utils/common_utils";
import {postLoginRoute} from "@/utils/oauth_consent";

export default {
  name: "SocialLoginButtons",
  data: () => ({
    googleLoaded: false,
  }),
  methods: {
    social_auth_github() {
      this.$gtag.event(constants.ANALYTICS_EVENTS.LOGIN, {method: 'github'});
      this.$store.dispatch('auth/social', 'github');
    },
    social_auth_google() {
      this.$gtag.event(constants.ANALYTICS_EVENTS.LOGIN, {method: 'google'});
      const userSource = getCookie('user_source');
      googleAuth.requestGoogleAuthCode().then((code) => {
        this.$store.dispatch('auth/social_received', {
          type: 'google',
          user_source: userSource ? userSource : 'direct',
          first_touch: getFirstTouch(),
          code
        })
            .then(() => this.$router.push(postLoginRoute()))
            .catch((err) => {
              const errorMsg = err?.response?.data?.error?.msg || '';
              if (errorMsg.includes('Access denied') && errorMsg.includes('IP address')) {
                this.$emit('ip-whitelist-blocked');
              }
              console.error(err);
            });
      })
          .catch(console.error);
    },
  },
  mounted() {
    googleAuth.load().then(
        () => this.googleLoaded = true,
    )
  }
}
</script>

<style scoped>
.md-svg-loader {
  display: inline-block;
}
</style>
